<template>
<div class="verification-prove">
    <h1>{{$lang('TITLE_CHECK_SUCCESS')}}</h1>
    <h2>
        <router-link :to="{name: 'home'}">{{$lang('TITLE_CLICK_LOGIN')}}</router-link>
    </h2>
</div>
</template>

<script>
export default {
    data() {
        return {
            loading: true,
            hash: this.$route.params.hash,
            emailValue: true,
        }
    },
    methods: {
        confirmMail() {
            this.$apis.user.confirmMail({
                hash: this.hash
            }).then(resp => {

            }).catch(err => {
                this.$router.push({
                    path: '/' + this.$route.params.locale + '/'
                })
            })
        },
        checkHashCode() {
            this.$apis.checkHashCode({
                hash: this.hash
            }).then(resp => {

            }).catch(err => {
                console.log(err)
                this.$router.push({
                    path: '/' + this.$route.params.locale + '/'
                })
            })
        }
    },
    created() {
        if (this.hash) {
            this.checkHashCode();
            this.confirmMail();
        }
    }
}
</script>
